import defaultThProject, {
  richblue as richblueThProject,
  light as lightThProject,
} from "./siamoption/siamoption";
import defaultiron, {
  richblue as richblueiron,
  light as lightiron,
  thProjectTrade,
} from "./irontrade/irontrade";
import defaulteztrader from "./eztrader/eztrader";

export {
  defaultThProject,
  richblueThProject,
  lightThProject,
  defaultiron,
  richblueiron,
  lightiron,
  thProjectTrade,
  defaulteztrader,
};



// WEBPACK FOOTER //
// ./src/themes/index.js